<template>
  <div class="person">
    <LoadingModal />
    <PersonIndex
      :showRechargeBtn="true"
      :info="userInfoData"
      :showClear="false"
      :count="couponCount"
    >
      <div class="carService pageMiddleMarginBottom">
        <Title title="我的车辆" @click="$push({ path: '/carList' })" />
        <!-- <div class="carBannar">
          <CarDetail :item="vehicleInfo[0]" :vehicle_service="vehicle_service" class="pageUserShadow" />
        </div> -->
      </div>
      <div class="pageCard pageUserShadow pageMiddleMarginBottom cells">
        <van-cell is-link :to="{ path: '/orders?type=-1' }">
          <div slot="title">
            <i class="iconfont iconu1113"></i>
            <span>我的订单</span>
          </div>
        </van-cell>
        <!-- <van-cell is-link to="/address">
          <div slot="title">
            <van-icon
              class="iconfont iconshouhuodizhi"
              color="var(--greenColor)"
            />
            <span>我的地址</span>
          </div>
        </van-cell> -->
        <!-- <van-cell
          is-link
          value-class="valueClass"
          :to="{
            path: '/updatePhone',
            query: {
              phone: userInfoData.mobile_phone,
              count: userInfoData.modify_count,
            },
          }"
        >
          <div slot="title">
            <i class="iconfont iconphone2f"></i>
            <span>手机号码</span>
          </div>
          <div class="phone">{{ userInfoData.mobile_phone }}</div>
        </van-cell> -->
      </div>
      <div
        class="pageCard pageUserShadow pageMiddleMarginBottom cells lightCell"
      >
        <!-- <van-cell is-link :to="{ path: '/help' }">
          <div slot="title">
            <i class="iconfont icon088help02"></i>
            <span>帮助反馈</span>
          </div>
        </van-cell> -->
        <van-cell v-if="phone != ''">
          <div slot="title">
            <i class="iconfont iconhtmal5icon31"></i>
            <span>服务咨询</span>
          </div>
          <a class="tel" :href="'tel:' + phone">{{ phone }}</a>
        </van-cell>
        <van-cell v-if="$getItem('appId') == 'wx71dfe531527f4985'">
          <div slot="title">
            <i class="iconfont iconhtmal5icon31"></i>
            <span>健康产品咨询</span>
          </div>
          <a class="tel" :href="'tel:' + '4001161638'">400-116-1638</a>
        </van-cell>
        <van-cell>
          <div slot="title">
            <i class="iconfont icontime"></i>
            <span>服务时间</span>
          </div>
          <span>工作日 8:30-18:00</span>
        </van-cell>
      </div>
    </PersonIndex>
  </div>
</template>
<script>
import PersonIndex from "common/PersonIndex";
import { getUserInfo, getCoupons } from "api/user";
// /*global $ */
export default {
  components: {
    PersonIndex,
  },
  data() {
    return {
      bgImg: require("assets/u602.png"),
      list: [],
      userInfoData: {
        balance: 0,
        coupons_count: 0,
      },
      vehicleInfo: [],
      vehicle_service: [],
      defaultImg: require("assets/user_bg.jpg"),
      tel: "",
      phone: "",
      old: 0,
      appid: "",
      dialogShow: false,
      authSuatus: false,
      b: true,
      couponCount: 0,
    };
  },
  mounted() {
    this.getUserInfo();
  },
  methods: {
    tourl() {
      location.href = this.url;
    },
    getUserInfo() {
      var that = this;
      getUserInfo().then((res) => {
        // this.$parent.$children[0].showFooter = true;
        if (res.status == 200) {
          this.userInfoData = res.data;
          if (that.userInfoData.userPhone != undefined) {
            getCoupons(0).then((res) => {
              that.couponCount = res.data.records.length;
            });
          } else {
            that.$push({ path: "/register" });
          }
        } else {
          this.$error(res.message);
        }
        this.$nextTick(() => {
          this.$store.commit("setPageLoading", false);
        });
      });
    },
    orders(e) {
      this.$push({ path: "/orders?type=" + e });
    },
    goBalance() {
      this.$push({
        path: "/recharge",
      });
    },
    goCoupon() {
      this.$push({
        path: "/coupons",
      });
    },
  },
};
</script>

<style scoped lang="less">
.loading {
  z-index: 9999;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  width: 100%;
  margin: 0;
  background-color: white;
  border: 1px solid white;
  div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    span {
      color: var(--depYelColor);
    }
  }
  h5 {
    color: var(--depYelColor);
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
.person {
  .carService {
    padding-top: 10px;
    .title {
      /deep/.name {
        color: var(--titleColor);
      }
      /deep/.editCar {
        color: var(--depHidColor);
      }
    }
    .carBannar {
      margin: 0 -20px;
      .listItem {
        overflow: hidden;
        margin: 10px 20px;
        // padding: 20px 0 0 20px;
        background-color: #fff;
        .carDetail {
          background-size: 100%;
          background-repeat: no-repeat;
          padding-bottom: 5%;
          h3 {
            font-size: 20px;
            color: var(--depBlueColor);
          }
          p {
            margin: 5px 0 3px;
            font-size: var(--pFont);
            color: #333;
          }
          span {
            font-size: var(--spanFont);
            color: #999;
          }
        }
        .footer {
          margin-left: -20px;
          border-top: 1px solid var(--lineColor);
          .left {
            width: 32%;
            padding: 5px;
            border-right: 1px solid var(--lineColor);
            .icon {
              position: relative;
              .iconfont {
                font-size: 30px;
                color: var(--redColor);
                margin-right: 8px;
              }
              span {
                position: absolute;
                top: -2px;
                right: 5px;
                width: 13px;
                height: 13px;
              }
            }
            span {
              font-size: var(--smallFont);
            }
          }
          .right {
            font-size: var(--smallFont);
            padding: 5px 10px 5px 5px;
            flex: 1;
            .text {
              width: 25px;
              height: 25px;
              background: var(--depBlueColor);
              border-radius: 50%;
              color: #fff;
              margin: 0 4px;
            }
            p {
              flex: 1;
              word-break: break-all;
            }
            .van-button--small {
              margin-left: auto;
              height: 24px;
              padding: 0 8px;
            }
          }
        }
        .unCurrent {
          opacity: 0.5;
          margin: 2px -10px;
        }
      }
    }
  }
  .cells {
    padding: 0 10px;
    color: var(--titleColor);
    border-radius: 10px;
    .van-cell {
      padding: 10px 0;
      font-size: var(--pFont);
      align-items: center;
      .tel {
        color: inherit;
      }
    }
    .van-cell::after {
      left: 0;
      right: 0;
    }
    span {
      vertical-align: middle;
      line-height: 1;
    }
    .iconfont {
      font-size: 24px;
      margin-right: 8px;
      vertical-align: sub;
    }
    .iconorders_fill {
      color: var(--redColor);
    }
    .iconphone2f {
      color: var(--depBlueColor);
    }
    .iconicon_gps_fill {
      color: var(--greenColor);
      font-size: 24px;
    }
    .iconperson_crop_square_fill {
      color: var(--blueColor);
      font-size: 25px;
    }
    .iconu1113 {
      color: #d9001b;
      font-size: 22px;
      margin-right: 4px;
    }
    .valueClass {
      width: 40%;
      flex: initial;
    }
    .phone {
      line-height: 26px;
    }
  }
  .lightCell {
    margin-top: 15px;
    .iconfont {
      color: var(--hidColor);
    }
  }
}
</style>
